const countries = [
  'AFGHANISTAN',
  'ALAND_ISLANDS',
  'ALBANIA',
  'ALGERIA',
  'AMERICAN_SAMOA',
  'ANDORRA',
  'ANGOLA',
  'ANGUILLA',
  'ANTARCTICA',
  'ANTIGUA_AND_BARBUDA',
  'ARGENTINA',
  'ARMENIA',
  'ARUBA',
  'ASCENSION_ISLAND',
  'AUSTRALIA',
  'AUSTRIA',
  'AZERBAIJAN',
  'BAHAMAS',
  'BANGLADESH',
  'BARBADOS',
  'BELARUS',
  'BELGIUM',
  'BELIZE',
  'BENIN',
  'BERMUDA',
  'BHUTAN',
  'BOLIVIA',
  'BOSNIA_AND_HERZEGOVINA',
  'BOTSWANA',
  'BOUVET_ISLAND',
  'BRAZIL',
  'BRITISH_INDIAN_OCEAN_TERRITORY',
  'BRUNEI_DARUSSALAM',
  'BULGARIA',
  'BURKINA_FASO',
  'BURUNDI',
  'CAMBODIA',
  'CAMEROON',
  'CANADA',
  'CAPE_VERDE',
  'CAYMAN_ISLANDS',
  'CENTRAL_AFRICAN_REPUBLIC',
  'CHAD',
  'CHILE',
  'CHINA',
  'CHRISTMAS_ISLAND',
  'COCOS_ISLANDS',
  'COLOMBIA',
  'COMOROS',
  'CONGO',
  'THE_DEMOCRATIC_REPUBLIC_OF_THE_CONGO',
  'COOK_ISLANDS',
  'COSTA_RICA',
  'COTE_D_IVOIRE',
  'CROATIA',
  'CUBA',
  'CYPRUS',
  'CZECH_REPUBLIC',
  'DENMARK',
  'DJIBOUTI',
  'DOMINICA',
  'DOMINICAN_REPUBLIC',
  'EAST_TIMOR',
  'ECUADOR',
  'EGYPT',
  'EL_SALVADOR',
  'EQUATORIAL_GUINEA',
  'ERITREA',
  'ESTONIA',
  'ETHIOPIA',
  'FALKLAND_ISLANDS',
  'FAROE_ISLANDS',
  'FIJI',
  'FINLAND',
  'FRANCE',
  'FRENCH_GUIANA',
  'FRENCH_POLYNESIA',
  'FRENCH_SOUTHERN_TERRITORIES',
  'GABON',
  'GAMBIA',
  'GEORGIA',
  'GERMANY',
  'GHANA',
  'GIBRALTAR',
  'GREECE',
  'GREENLAND',
  'GRENADA',
  'GUADELOUPE',
  'GUAM',
  'GUATEMALA',
  'GUERNSEY',
  'GUINEA',
  'GUINEA_BISSAU',
  'GUYANA',
  'HAITI',
  'HEARD_ISLAND_AND_MCDONALD_ISLANDS',
  'HOLY_SEE',
  'HONDURAS',
  'HONG_KONG',
  'HUNGARY',
  'ICELAND',
  'INDIA',
  'INDONESIA',
  'ISLAMIC_REPUBLIC_OF_IRAN',
  'IRAQ',
  'IRELAND',
  'ISLE_OF_MAN',
  'ISRAEL',
  'ITALY',
  'JAMAICA',
  'JAPAN',
  'JERSEY',
  'JORDAN',
  'KAZAKHSTAN',
  'KENYA',
  'KIRIBATI',
  'DEMOCRATIC_PEOPLES_REPUBLIC_OF_KOREA',
  'REPUBLIC_OF_KOREA',
  'KOSOVO',
  'KUWAIT',
  'KYRGYZSTAN',
  'LAO_PEOPLES_DEMOCRATIC_REPUBLIC',
  'LATVIA',
  'LEBANON',
  'LESOTHO',
  'LIBERIA',
  'LIBYAN_ARAB_JAMAHIRIYA',
  'LIECHTENSTEIN',
  'LITHUANIA',
  'LUXEMBOURG',
  'MACAO',
  'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA',
  'MADAGASCAR',
  'MALAWI',
  'MALAYSIA',
  'MALDIVES',
  'MALI',
  'MALTA',
  'MARSHALL_ISLANDS',
  'MARTINIQUE',
  'MAURITANIA',
  'MAURITIUS',
  'MAYOTTE',
  'MEXICO',
  'FEDERATED_STATES_OF_MICRONESIA',
  'REPUBLIC_OF_MOLDOVA',
  'MONACO',
  'MONGOLIA',
  'MONTENEGRO',
  'MONTSERRAT',
  'MOROCCO',
  'MOZAMBIQUE',
  'MYANMAR',
  'NAMIBIA',
  'NAURU',
  'NEPAL',
  'NETHERLANDS',
  'NETHERLANDS_ANTILLES',
  'NEW_CALEDONIA',
  'NEW_ZEALAND',
  'NICARAGUA',
  'NIGER',
  'NIGERIA',
  'NIUE',
  'NORFOLK_ISLAND',
  'NORTHERN_MARIANA_ISLANDS',
  'NORWAY',
  'OMAN',
  'PAKISTAN',
  'PALAU',
  'OCCUPIED_PALESTINIAN_TERRITORY',
  'PANAMA',
  'PAPUA_NEW_GUINEA',
  'PARAGUAY',
  'PERU',
  'PHILIPPINES',
  'PITCAIRN',
  'POLAND',
  'PORTUGAL',
  'PUERTO_RICO',
  'QATAR',
  'REUNION',
  'ROMANIA',
  'RUSSIAN_FEDERATION',
  'RWANDA',
  'SAINT_HELENA',
  'SAINT_KITTS_AND_NEVIS',
  'SAINT_LUCIA',
  'SAINT_PIERRE_AND_MIQUELON',
  'SAINT_VINCENT_AND_THE_GRENADINES',
  'SAMOA',
  'SAN_MARINO',
  'SAO_TOME_AND_PRINCIPE',
  'SAUDI_ARABIA',
  'SENEGAL',
  'SERBIA',
  'SEYCHELLES',
  'SIERRA_LEONE',
  'SINGAPORE',
  'SLOVAKIA',
  'SLOVENIA',
  'SOLOMON_ISLANDS',
  'SOMALIA',
  'SOUTH_AFRICA',
  'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS',
  'SPAIN',
  'SRI_LANKA',
  'SUDAN',
  'SURINAME',
  'SVALBARD_AND_JAN_MAYEN',
  'SWAZILAND',
  'SWEDEN',
  'SWITZERLAND',
  'SYRIAN_ARAB_REPUBLIC',
  'TAIWAN_PROVINCE_OF_CHINA',
  'TAJIKISTAN',
  'UNITED_REPUBLIC_OF_TANZANIA',
  'THAILAND',
  'TIMOR_LESTE',
  'TOGO',
  'TOKELAU',
  'TONGA',
  'TRINIDAD_AND_TOBAGO',
  'TUNISIA',
  'TURKEY',
  'TURKMENISTAN',
  'TURKS_AND_CAICOS_ISLANDS',
  'TUVALU',
  'UGANDA',
  'UKRAINE',
  'UNITED_ARAB_EMIRATES',
  'UNITED_KINGDOM',
  'UNITED_STATES',
  'UNITED_STATES_MINOR_OUTLYING_ISLANDS',
  'URUGUAY',
  'UZBEKISTAN',
  'VANUATU',
  'VENEZUELA',
  'VIETNAM',
  'BRITISH_VIRGIN_ISLANDS',
  'US_VIRGIN_ISLANDS',
  'WALLIS_AND_FUTUNA',
  'WESTERN_SAHARA',
  'YEMEN',
  'ZAMBIA',
  'ZIMBABWE',
];
const CountryOptions = new Map();
countries.forEach((each) => CountryOptions.set(each, each));
export default CountryOptions;
